// extracted by mini-css-extract-plugin
module.exports = {"block":"Menu_block__23G9D","backDrop":"Menu_backDrop__InBcq"};